import logo from './logo.svg';
import './App.css';
import SchoolOnboardingForm from './Component/SchoolOnboardingForm';

function App() {
  return (
    <>
    <SchoolOnboardingForm/>
    </>
    
  );
}

export default App;
